import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl" style={{ color: "oklch(var(--accent-500))" }}></i>
              </div>
              <span className="text-lg font-semibold text-background-50">丁香花影院</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              您的专属在线影院，提供最新最全的高清电影电视剧资源，极致的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                首页
              </Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                关于我们
              </Link>
              {categories.slice(5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-background-50/60">邮箱: contact@lilaccinema.com</p>
              <p className="text-sm text-background-50/60">微信: 丁香花影院官方</p>
              <p className="text-sm text-background-50/60">工作时间: 周一至周日 9:00-22:00</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} 丁香花影院 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors duration-200 whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors duration-200 whitespace-nowrap">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}